




























































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import moment from "moment-timezone";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import OtherContributionForm from "@/employee/components/contributionsV2/OtherContributionForm.vue";
import Button from "@/shared/components/ui/Button.vue";
import _ from "lodash";
import { useContributionStore } from "@/shared/store/contribution";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner,
    Button,
    ContributionsGraphWidget,
    OtherContributionForm
  }
})

export default class ManageOtherHsaAmount extends Vue {
  contributionStore = useContributionStore();
  hsaTotalStore = useHsaTotalStore();
  isSubmitting = false;
  selectedYear = moment().year();
  otherHsaAmount = 0;

  mounted () {
    this.contributionStore.getOtherHsaPriorYearCutoffDate();
    this.hsaTotalStore.loadOtherHsaAmounts();
    this.storedOtherHsaAmountChanged();
  }

  get storedOtherHsaAmount () {
      return this.hsaTotalStore.otherHsaAmount(this.selectedYear);
  }

  get isLoaded () {
    return this.contributionStore.otherHsaPriorYearCutoffDateLoaded && this.hsaTotalStore.otherHsaAmountsLoaded;
  }

  get yearsThrough (): number[] {
    return _.range(this.contributionStore.firstPlanEffectiveYear, moment().year() + 1).reverse();
  }

  @Watch("storedOtherHsaAmount")
  storedOtherHsaAmountChanged () {
    this.otherHsaAmount = this.storedOtherHsaAmount;
  }

  get yearOptions (): { text: string, value: string | number }[] {
    return this.yearsThrough
        .map(year => ({
          text: year.toString(),
          value: year
        }));
  }

  get isCurrentYear (): boolean {
    return this.selectedYear === moment().year();
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }

    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }
      this.isSubmitting = true;
      this.hsaTotalStore.updateOtherHsa({ amount: this.otherHsaAmount, year: this.selectedYear })
          .finally(() => {
            this.isSubmitting = false;
          });
    });
  }
}
